import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Injector,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
	TemplateRef,
	ViewChild,
	ViewContainerRef,
} from '@angular/core';
import { ExpansionService } from '../../expansion.service';
import { ExpanderCluster } from '../../types/expanderCluster';

export interface ExpansionComponent<EXPANSION_CONTEXT> {
	context: EXPANSION_CONTEXT;
}

@Component({
	selector: 'ws-expander',
	templateUrl: './expander.component.html',
})
export class ExpanderComponent<COMPONENT_INTERFACE extends Record<string, any> = Record<string, any>>
	implements AfterViewInit, OnChanges
{
	@ViewChild('container', { read: ViewContainerRef }) container!: ViewContainerRef;
	@Input() wrapperTemplate?: TemplateRef<any>;
	@Input() scope!: string;
	@Input() contextName: string = 'context';
	@Input() styleClass?: string;
	@Input() context!: any;
	@Input() show = true;
	@Output() contextChange: EventEmitter<any> = new EventEmitter<any>();
	@Output() clusterReady: EventEmitter<void> = new EventEmitter<void>();

	// @ts-ignore
	protected cluster!: ExpanderCluster = new ExpanderCluster();
	protected clusterInitialized = false;
	protected ready = false;

	constructor(protected expansionService: ExpansionService, protected cdr: ChangeDetectorRef) {}

	ngAfterViewInit(): void {
		this.ready = true;
		if (this.show) {
			this.initCluster();
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (this.show && this.ready) {
			this.initCluster();
		}
	}

	public call(method: string, params?: any) {
		this.cluster?.call(method, params);
	}

	public callDeferred(method: string, params?: any) {
		return this.cluster?.callDeferred(method, params);
	}

	public forEachInstance(callback: (instanceId: string, component: any) => void): void {
		for (const instance of this.cluster?.instances || []) {
			callback(instance.id, instance.ref?.instance);
		}
	}

	public callEach(method: string, callback: (instanceId: string, component: any) => void, params?: any): void {
		for (const instance of this.cluster?.instances || []) {
			if (typeof instance.ref?.instance[method] === 'function') {
				instance.ref.instance[method](params);
			}
			callback(instance.id, instance.ref?.instance);
		}
	}

	protected initCluster() {
		if (!this.clusterInitialized) {
			this.cluster.pushInstances(
				this.expansionService.applyExpansions(this.scope, this.container, this.styleClass)
			);

			this.cluster.assign(this.contextName, this.context);

			this.clusterInitialized = true;

			this.cdr.detectChanges();
			setTimeout(() => {
				this.clusterReady.emit();
			});
		}
	}
}
